import React, { useEffect, useRef } from "react";
import { useMap } from "react-map-gl"; // Import Mapbox components
import { useMapboxDraw, MeasureMode } from "../../DrawToolProvider";
import { draw_polygon } from "../../../../assets/images";
import { useSelector, useDispatch } from "react-redux";
import { inputsActions } from "../../..";
import { Tooltip } from "antd";

const DrawPolygon = () => {
  const { current: mapRef } = useMap();
  const map = mapRef.getMap();
  const draw = useMapboxDraw();
  const dispatch = useDispatch();

  const is_drawing = useSelector((state) => state.inputs.uiState.is_drawing);
  const is_drawing_ref = useRef(is_drawing);
  const is_measuring = useSelector((state) => state.inputs.uiState.is_measuring);

  useEffect(() => {
    is_drawing_ref.current = is_drawing;
  }, [is_drawing]);

  return (
    <Tooltip title="Draw Polygon" placement="bottom" mouseEnterDelay={0.25}>
      <button className={is_drawing ? "button-active" : ""} onClick={() => map.fire("draw.polygon")}>
        <img draggable={false} src={draw_polygon} />
      </button>
    </Tooltip>
  );
};

export { DrawPolygon };
